module.exports = require('../impls/object-from-async/object-from-async.js').objectFromAsync;